var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"terrain-public-access"},[_c('section',[_c('h1',[_vm._v("Abriendo invitación")]),(_vm.loading)?_c('p',[_vm._v("Validando acceso…")]):_c('p',{attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errorMessage))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }